import { Table, Typography } from 'antd';
import { DateTime } from 'luxon';

import { ShiftListItemDto } from '@clh/api-client';
import { HumlaDateTime } from '@clh/util';

export const NurseCancellationsTable = ({
    selection,
}: {
    selection: ShiftListItemDto;
}) => {
    if (selection.cancellations.length === 0) {
        return null;
    }

    return (
        <>
            <Typography.Title level={4}>Nurse Cancellations</Typography.Title>

            <Table
                rowKey="id"
                bordered
                dataSource={selection.cancellations}
                columns={[
                    {
                        dataIndex: 'nurseProfile',
                        title: 'Nurse',
                        render: (nurseProfile) => (
                            <>
                                {nurseProfile.firstName} {nurseProfile.lastName}
                            </>
                        ),
                    },
                    {
                        dataIndex: 'createdAt',
                        title: 'Canceled at',
                        render: (createdAt: Date) => (
                            <>
                                {DateTime.fromJSDate(createdAt).toLocaleString(
                                    HumlaDateTime.DATETIME_SHORT
                                )}
                            </>
                        ),
                    },
                    {
                        dataIndex: 'canceledByProfile',
                        title: 'Canceled by',
                        render: (canceledByProfile) =>
                            canceledByProfile
                                ? `${canceledByProfile.firstName} ${canceledByProfile.lastName}`
                                : null,
                    },
                    { dataIndex: 'reason', title: 'Reason' },
                    { dataIndex: 'comment', title: 'Comment' },
                ]}
            />
        </>
    );
};
